var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcoPhone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.835,
    height: 23.674,
    viewBox: "0 0 20.835 23.674",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.913,23.674,10.862,7.682a1.572,1.572,0,0,1,0-2.225h0L16.319,0l3.788,3.764a1.583,1.583,0,0,1,.012,2.225L20.106,6,18.769,7.327l5.788,5.765,2.427-2.427,3.788,3.764a1.583,1.583,0,0,1,.012,2.225l-.012.012-1.752,1.74L28.2,17.59l1.752-1.74a.414.414,0,0,0,0-.592h0l-2.971-2.947-2.427,2.427-7.434-7.41L19.29,5.185a.414.414,0,0,0,0-.592h0L16.319,1.634l-4.64,4.628a.414.414,0,0,0,0,.592h0L27.718,22.846Z",
    transform: "translate(-10.4)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcoPhone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico_phone.800b087d.svg";
export { ForwardRef as ReactComponent };